import { apiGet, apiPost, apiPut } from '../../generic/Api_Functions'

/**
 * Historia 176 — CU2/CU5, T3/T7. Thin wrapper of the four routes frozen in `03-dominio.md`
 * §"Contrato cross-repo congelado" §2. `restoreTerm` and `getHistory` are added when the
 * scenarios that need them land — adding them now would be code no test of this tanda demands.
 *
 * @param {string} code Custom language code (e.g. `es-acme`)
 * @returns {Promise<{code: string, fileState: string, terms: Object}>} `CustomLanguageTermsDto`
 */
export const getTerms = (code) => apiGet(`languages/custom/${code}/terms`)

/**
 * 03 §2.2: fixes or deletes a term. `value` travels verbatim (RN14), never trimmed; `''` deletes
 * (RN12, "Undo customisation" always sends this).
 *
 * @param {string} code Custom language code
 * @param {string} key The i18n key, verbatim
 * @param {string} value The new value, or `''` to delete
 * @returns {Promise<{key: string, value: (string|null), change: (Object|null)}>} `TermResultDto`
 */
export const setTerm = (code, key, value) => apiPut(`languages/custom/${code}/terms`, { key, value })

/**
 * 03 §2.3: reponer desde una entrada del histórico.
 *
 * @param {string} code Custom language code
 * @param {number} changeId `TermChangeDto.id` to restore
 * @returns {Promise<{key: string, value: (string|null), change: (Object|null)}>} `TermResultDto`
 */
export const restoreTerm = (code, changeId) => apiPost(`languages/custom/${code}/terms/restore`, { changeId })

/**
 * 03 §2.4: every entry of the language's history, most recent first. Jupiter filters by key.
 *
 * @param {string} code Custom language code
 * @returns {Promise<Array>} `TermChangeDto[]`
 */
export const getHistory = (code) => apiGet(`languages/custom/${code}/terms/history`)

/**
 * Story 204 — C5: Sun's system-value catalogue (SUPERADMIN only; 401/403 otherwise).
 *
 * @returns {Promise<{version: number, values: Array<{kind: string, domain: string, code: string, defaultText: string, params: string[]}>}>}
 *   The JSON of C6: the catalogue Sun builds in memory from what its code declares
 */
export const getSystemValues = () => apiGet('languages/system-values')
